export interface AdvancedApiConfig {
  apiName: string;
  apiUrl: string;
  advanced: boolean;
  advancedDesc: string;
}

const normalizePath = (path: string) =>
  path.trim().replace(/\/+$/, "").toLowerCase();

export const getAdvancedFeatureByApiUrl = (
  configs: AdvancedApiConfig[],
  apiUrl?: string
) => {
  if (!apiUrl) return undefined;
  const normalizedApiUrl = normalizePath(apiUrl);
  return configs.find(
    (config) =>
      config.advanced === true &&
      normalizePath(config.apiUrl || "") === normalizedApiUrl
  );
};
